import {
  Analytics,
  setUserId as firebaseSetUserId,
  setUserProperties as firebaseSetUserProperties,
  getAnalytics,
  logEvent
} from "firebase/analytics";

import { ANALYTICS_CONFIG } from "./config";

// Firebase Analytics instance
let analytics: Analytics | null = null;

// Initialize Firebase Analytics
export const initAnalytics = () => {
  if (!ANALYTICS_CONFIG.enabled) {
    console.warn("Analytics disabled");
    return;
  }

  try {
    analytics = getAnalytics();
    console.log("Firebase Analytics initialized");
  } catch (error) {
    console.error("Failed to initialize Firebase Analytics:", error);
  }
};

// Track page views
export const trackPageView = (pagePath: string, pageTitle?: string) => {
  if (!analytics) return;

  logEvent(analytics, "page_view", {
    page_path: pagePath,
    page_title: pageTitle || document.title,
    page_location: window.location.href
  });
};

// Track custom events
export const trackEvent = (
  eventName: string,
  parameters?: {
    event_category?: string;
    event_label?: string;
    value?: number;
    [key: string]: any;
  }
) => {
  if (!analytics) return;

  logEvent(analytics, eventName, parameters);
};

// Track user login
export const trackLogin = (method: string) => {
  trackEvent("login", {
    method: method
  });
};

// Track credit/payment events
export const trackPaymentStart = (amount: number, currency: string = "VND") => {
  trackEvent("payment_start", {
    event_category: "payment",
    currency: currency,
    value: amount
  });
};

// Track user engagement
export const trackEngagement = (action: string, category: string, label?: string) => {
  trackEvent("engagement", {
    event_category: category,
    event_label: label,
    action: action
  });
};

// Track errors
export const trackError = (errorMessage: string, errorCode?: string) => {
  trackEvent("error", {
    event_category: "error",
    event_label: errorMessage,
    error_code: errorCode
  });
};

// Set user properties
export const setUserProperties = (properties: {
  user_id?: string;
  user_type?: string;
  [key: string]: any;
}) => {
  if (!analytics) return;

  firebaseSetUserProperties(analytics, properties);
};

// Set user ID
export const setUserId = (userId: string) => {
  if (!analytics) return;

  firebaseSetUserId(analytics, userId);
};
